import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-product-unit',
  templateUrl: './product-unit.component.html',
  styleUrls: ['./product-unit.component.css']
})
export class ProductUnitComponent implements OnInit {
    prodId;

    productUnitKeyno;

    public edit?: Edit;

    public selectListNewProductUnits: NewProductUnitItem[] = [];

    public saving = false;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.prodId = this.stateService.getStateParams()['prod_id'];
        this.productUnitKeyno = this.stateService.getStateParams()['productunit_keyno'];
    }

    private async loadEdit() {
        if (!!this.prodId && !!this.productUnitKeyno) {
            this.edit = (await this.datatask.Post(581, {
                prod_id: this.prodId,
                productunit_keyno: this.productUnitKeyno
            }))[0];
        }
    }

    private async loadNewProductUnits() {
        if (!this.edit) return;

        this.selectListNewProductUnits = await this.datatask.Post(582, { prod_id: this.edit.prod_id });
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(583, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    const response = (await this.datatask.Post(590, this.edit))[0];

                    if (response.errorcode !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            message: response.errormessage
                        });
                    } else {
                        this.stateService.back();
                    }
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadNewProductUnits();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    productunit_keyno: string;
    unit_no: string;
    prod_id: string;
    unit_name_shortname: string;
    isnew: string;
}

interface NewProductUnitItem {
    unit_no: string;
    unit_name: string;
}
